export const ThumbnailListType = {
  Default: "default",
  VideoForCode: "videoForCode",
  FormsAndTests: "formsAndTests",
  AmbassadorsBusinessCards: "ambassadorsBusinessCards",
};
